class CustomBookingForm extends HTMLElement {
    connectedCallback() {
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: block;
                }
                .form-container {
                    padding: 2rem;
                }
                .form-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 1.5rem;
                    font-weight: 600;
                    margin-bottom: 1.5rem;
                    color: #1e293b;
                    text-align: center;
                }
                .form-step {
                    display: none;
                }
                .form-step.active {
                    display: block;
                }
                .form-group {
                    margin-bottom: 1.25rem;
                }
                .form-label {
                    display: block;
                    margin-bottom: 0.5rem;
                    font-weight: 500;
                    color: #334155;
                }
                .form-input {
                    width: 100%;
                    padding: 0.75rem;
                    border: 1px solid #e2e8f0;
                    border-radius: 0.375rem;
                    font-size: 1rem;
                }
                .form-input:focus {
                    outline: none;
                    border-color: #981010;
                    box-shadow: 0 0 0 3px rgba(152, 16, 16, 0.1);
                }
                .form-actions {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 2rem;
                }
                .form-btn {
                    padding: 0.75rem 1.5rem;
                    border-radius: 0.375rem;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.3s;
                }
                .form-btn.next {
                    background-color: #981010;
                    color: white;
                    border: none;
                }
                .form-btn.next:hover {
                    background-color: #720c0c;
                }
                .form-btn.prev {
                    background-color: white;
                    color: #334155;
                    border: 1px solid #e2e8f0;
                }
                .form-btn.prev:hover {
                    background-color: #f8fafc;
                }
                .form-btn.submit {
                    background-color: #981010;
                    color: white;
                    border: none;
                    width: 100%;
                }
                .form-btn.submit:hover {
                    background-color: #720c0c;
                }
                .progress-bar {
                    height: 4px;
                    background-color: #e2e8f0;
                    margin-bottom: 2rem;
                    border-radius: 2px;
                }
                .progress {
                    height: 100%;
                    background-color: #981010;
                    border-radius: 2px;
                    transition: width 0.3s;
                    width: 25%;
                }
                .radio-group {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 1rem;
                }
                .radio-option {
                    flex: 1 1 calc(50% - 0.5rem);
                    min-width: 120px;
                }
                .radio-input {
                    display: none;
                }
                .radio-label {
                    display: block;
                    padding: 1rem;
                    border: 1px solid #e2e8f0;
                    border-radius: 0.375rem;
                    text-align: center;
                    cursor: pointer;
                    transition: all 0.3s;
                }
                .radio-input:checked + .radio-label {
                    border-color: #981010;
                    background-color: #f8e8e8;
                }
                @media (max-width: 640px) {
                    .radio-option {
                        flex: 1 1 100%;
                    }
                }
            </style>
            <div class="form-container">
                <h2 class="form-title">Request a Quote</h2>
                <div class="progress-bar">
                    <div class="progress" id="progress"></div>
                </div>
                
                <!-- Step 1 -->
                <div class="form-step active" id="step1">
                    <div class="form-group">
                        <label class="form-label">What type of service do you need?</label>
                        <div class="radio-group">
                            <div class="radio-option">
                                <input type="radio" name="serviceType" id="residential" value="residential" class="radio-input" checked>
                                <label for="residential" class="radio-label">Residential</label>
                            </div>
                            <div class="radio-option">
                                <input type="radio" name="serviceType" id="commercial" value="commercial" class="radio-input">
                                <label for="commercial" class="radio-label">Commercial</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-actions">
                        <div></div>
                        <button type="button" class="form-btn next" onclick="this.getRootNode().host.nextStep()">Next</button>
                    </div>
                </div>
                
                <!-- Step 2 -->
                <div class="form-step" id="step2">
                    <div class="form-group">
                        <label class="form-label">What service are you interested in?</label>
                        <select class="form-input" name="service">
                            <!-- Base Cleaning Packages -->
                            <option value="residential-maintenance">Residential Maintenance Clean</option>
                            <option value="residential-deep">Residential Deep Clean</option>
                            <option value="event-reset">After-Event Renew & Reset</option>
                            <option value="move-in-out">Move-In/Move-Out Clean</option>
                            <option value="post-construction">Post-Construction Clean</option>
                            <option value="airbnb-maintenance">Routine Airbnb Maintenance</option>
                            
                            <!-- Luxury Packages -->
                            <option value="venue-revival">Venue Revival Concert Cleaning</option>
                            <option value="rental-revival">Rental Revival Deep Clean</option>
                            <option value="executive-office">Executive Office Maintenance</option>
                            <option value="estate-maintenance">Estate Routine Maintenance</option>
                            <option value="property-prep">Residential Property Preparation</option>
                            
                            <!-- Refuse Removal -->
                            <option value="residential-clear">Residential Clear & Carry</option>
                            <option value="big-bin">Big Bin Rentals</option>
                            <option value="estate-refresh">Estate Property Refresh</option>
                            <option value="storage-refresh">Storage Unit Refresh</option>
                            <option value="garage-revival">Garage Revival Deep Clean</option>
                            <option value="barn-cleanout">Heritage Barn Clean-Out</option>
                            <option value="other">Other (Please Specify)</option>
</select>
                    </div>
                    <div class="form-group" id="other-service-group" style="display: none;">
                        <label class="form-label">Please specify</label>
                        <input type="text" class="form-input" name="otherService">
                    </div>
                    <div class="form-actions">
                        <button type="button" class="form-btn prev" onclick="this.getRootNode().host.prevStep()">Back</button>
                        <button type="button" class="form-btn next" onclick="this.getRootNode().host.nextStep()">Next</button>
                    </div>
                </div>
                
                <!-- Step 3 -->
                <div class="form-step" id="step3">
                    <div class="form-group">
                        <label class="form-label">Approximate square footage</label>
                        <select class="form-input" name="squareFootage">
                            <option value="under-1000">Under 1,000 sq ft</option>
                            <option value="1000-2000">1,000 - 2,000 sq ft</option>
                            <option value="2000-3000">2,000 - 3,000 sq ft</option>
                            <option value="3000-4000">3,000 - 4,000 sq ft</option>
                            <option value="over-4000">Over 4,000 sq ft</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Number of bedrooms/bathrooms or offices</label>
                        <input type="text" class="form-input" name="rooms" placeholder="e.g., 3 bedrooms, 2 bathrooms">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Location (City/ZIP)</label>
                        <input type="text" class="form-input" name="location" required>
                    </div>
                    <div class="form-actions">
                        <button type="button" class="form-btn prev" onclick="this.getRootNode().host.prevStep()">Back</button>
                        <button type="button" class="form-btn next" onclick="this.getRootNode().host.nextStep()">Next</button>
                    </div>
                </div>
                
                <!-- Step 4 -->
                <div class="form-step" id="step4">
                    <div class="form-group">
                        <label class="form-label">Preferred timing</label>
                        <div class="radio-group">
                            <div class="radio-option">
                                <input type="radio" name="timing" id="overnight" value="overnight" class="radio-input" checked>
                                <label for="overnight" class="radio-label">Overnight</label>
                            </div>
                            <div class="radio-option">
                                <input type="radio" name="timing" id="while-away" value="while-away" class="radio-input">
                                <label for="while-away" class="radio-label">While You're Away</label>
                            </div>
                            <div class="radio-option">
                                <input type="radio" name="timing" id="daytime" value="daytime" class="radio-input">
                                <label for="daytime" class="radio-label">Daytime</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Preferred days</label>
                        <input type="text" class="form-input" name="preferredDays" placeholder="e.g., Mondays and Thursdays">
                    </div>
                    <div class="form-group">
                        <label class="form-label">Frequency</label>
                        <div class="radio-group">
                            <div class="radio-option">
                                <input type="radio" name="frequency" id="one-time" value="one-time" class="radio-input" checked>
                                <label for="one-time" class="radio-label">One-time</label>
                            </div>
                            <div class="radio-option">
                                <input type="radio" name="frequency" id="weekly" value="weekly" class="radio-input">
                                <label for="weekly" class="radio-label">Weekly</label>
                            </div>
                            <div class="radio-option">
                                <input type="radio" name="frequency" id="bi-weekly" value="bi-weekly" class="radio-input">
                                <label for="bi-weekly" class="radio-label">Bi-weekly</label>
                            </div>
                            <div class="radio-option">
                                <input type="radio" name="frequency" id="monthly" value="monthly" class="radio-input">
                                <label for="monthly" class="radio-label">Monthly</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-actions">
                        <button type="button" class="form-btn prev" onclick="this.getRootNode().host.prevStep()">Back</button>
                        <button type="button" class="form-btn next" onclick="this.getRootNode().host.nextStep()">Next</button>
                    </div>
                </div>
                
                <!-- Step 5 -->
                <div class="form-step" id="step5">
                    <div class="form-group">
                        <label class="form-label">Full Name</label>
                        <input type="text" class="form-input" name="fullName" required>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Phone Number</label>
                        <input type="tel" class="form-input" name="phone" required>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Email Address</label>
                        <input type="email" class="form-input" name="email" required>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Special Instructions (Optional)</label>
                        <textarea class="form-input" name="instructions" rows="3"></textarea>
                    </div>
                    <div class="form-actions">
                        <button type="button" class="form-btn prev" onclick="this.getRootNode().host.prevStep()">Back</button>
                        <button type="submit" class="form-btn submit">Submit Request</button>
                    </div>
                </div>
            </div>
        `;
    }

    nextStep() {
        const currentStep = this.shadowRoot.querySelector('.form-step.active');
        const nextStep = currentStep.nextElementSibling;
        
        if (nextStep) {
            currentStep.classList.remove('active');
            nextStep.classList.add('active');
            this.updateProgress();
        }
    }

    prevStep() {
        const currentStep = this.shadowRoot.querySelector('.form-step.active');
        const prevStep = currentStep.previousElementSibling;
        
        if (prevStep) {
            currentStep.classList.remove('active');
            prevStep.classList.add('active');
            this.updateProgress();
        }
    }

    updateProgress() {
        const steps = this.shadowRoot.querySelectorAll('.form-step');
        const currentStep = this.shadowRoot.querySelector('.form-step.active');
        const currentIndex = Array.from(steps).indexOf(currentStep);
        const progressPercentage = (currentIndex / (steps.length - 1)) * 100;
        
        this.shadowRoot.getElementById('progress').style.width = `${progressPercentage}%`;
    }
}
customElements.define('custom-booking-form', CustomBookingForm);